import props from "./../../../src-utils/propDefiner";

export default {};
